/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetRecommendationsDto
 */
export interface GetRecommendationsDto {
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationsDto
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof GetRecommendationsDto
     */
    scopeType: GetRecommendationsDtoScopeTypeEnum;
}


/**
 * @export
 */
export const GetRecommendationsDtoScopeTypeEnum = {
    Global: 'Global',
    Company: 'Company',
    Purchaser: 'Purchaser'
} as const;
export type GetRecommendationsDtoScopeTypeEnum = typeof GetRecommendationsDtoScopeTypeEnum[keyof typeof GetRecommendationsDtoScopeTypeEnum];


/**
 * Check if a given object implements the GetRecommendationsDto interface.
 */
export function instanceOfGetRecommendationsDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "scopeType" in value;

    return isInstance;
}

export function GetRecommendationsDtoFromJSON(json: any): GetRecommendationsDto {
    return GetRecommendationsDtoFromJSONTyped(json, false);
}

export function GetRecommendationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRecommendationsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'scopeType': json['scopeType'],
    };
}

export function GetRecommendationsDtoToJSON(value?: GetRecommendationsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientId': value.clientId,
        'scopeType': value.scopeType,
    };
}

